import C001AreasArchivo from '../../../src/components/ArchivoJudicial/Comun/Catalogos/001Areas.vue'
import C004TipoEstatusVolumen from '../../../src/components/ArchivoJudicial/Comun/Catalogos/004TipoEstatusVolumenes.vue'
import C003TipoEstatusDocumento from '../../../src/components/ArchivoJudicial/Comun/Catalogos/003TipoEstatusInventarioDocumento.vue'
import C012SedesArchivo from '../../../src/components/ArchivoJudicial/Comun/Catalogos/012SedesArchivo.vue'
import C014TipoEstatusReferencia from '../../../src/components/ArchivoJudicial/Comun/Catalogos/014TipoEstatusReferencia.vue'
import C016AreasExternas from '../../../src/components/ArchivoJudicial/Comun/Catalogos/016TipoAreasExternas.vue'

const archivo =[
    {Proviene: 'ArchivoJudicial', Nombre: 'C001Areas', datos: C001AreasArchivo},
    {Proviene: 'ArchivoJudicial', Nombre: 'C004TipoEstatusVolumen', datos: C004TipoEstatusVolumen },
    {Proviene: 'ArchivoJudicial', Nombre: 'C003TipoEstatusDocumento', datos: C003TipoEstatusDocumento},
    {Proviene: 'ArchivoJudicial', Nombre: 'C012SedesArchivo', datos: C012SedesArchivo},
    {Proviene: 'ArchivoJudicial', Nombre: 'C014TipoEstatusReferencia', datos: C014TipoEstatusReferencia},
    {Proviene: 'ArchivoJudicial', Nombre: 'C016AreasExternas', datos: C016AreasExternas},

]
export default archivo;



//////////////////
// WEBPACK FOOTER
// ./static/js/catalogos/archivojudicial.js
// module id = null
// module chunks = 